/* ---------- utilities ---------- */

export const $ = <E extends Element = HTMLElement>(sel: string, root: ParentNode = document) =>
  root.querySelector<E>(sel);
export const $$ = <E extends Element = HTMLElement>(sel: string, root: ParentNode = document) => [
  ...root.querySelectorAll<E>(sel),
];
export const textOf = (node: Node) => (node.textContent ?? '').trim();
// \s already covers NBSP + BOM
export const clean = (s = '') =>
  s
    .replace(/[\u200B-\u200D]/g, '')
    .replace(/\s+/g, ' ')
    .trim();
export const el = (tag: string, className: string) => Object.assign(document.createElement(tag), { className });
/** setAttribute stringifies anyway; typing it loosely keeps call sites (booleans for ARIA, numbers for indexes) terse. */
export const setAttrs = (node: Element, props: Record<string, string | number | boolean>) =>
  Object.entries(props).forEach(([k, v]) => node.setAttribute(k, String(v)));
export const enc = encodeURIComponent;
export const EXTERNAL = { target: '_blank', rel: 'noopener noreferrer' } as const;
/** lib.dom types cloneNode as Node; this is the one cast in the codebase. */
export const clone = <T extends Node>(node: T): T => node.cloneNode(true) as T;
